function PausedGoalsGraphic({}) {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 142 162'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M69.9892 155.057C104.314 155.057 132.275 134.833 133.57 109.549H6.41016C7.70544 134.835 35.6798 155.057 69.991 155.057H69.9892Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.78883 122.671C4.26218 122.671 5.46145 121.45 5.46145 119.951C5.46145 118.451 4.26392 117.23 2.78883 117.23C1.31374 117.23 0.116211 118.45 0.116211 119.951C0.116211 121.452 1.31549 122.671 2.78883 122.671Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M137.477 103.73C139.907 103.73 141.885 101.671 141.885 99.1347C141.885 96.5987 139.91 94.5391 137.477 94.5391C135.045 94.5391 133.07 96.6017 133.07 99.1347C133.07 101.668 135.048 103.73 137.477 103.73Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M41.1531 161.505C43.2158 161.505 44.9282 159.72 44.9282 157.566C44.9282 155.412 43.2158 153.627 41.1531 153.627C39.0903 153.627 37.373 155.412 37.373 157.566C37.373 159.72 39.0854 161.505 41.1531 161.505Z'
        fill='#625FDB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M128.156 144.189C129.629 144.189 130.829 142.968 130.829 141.468C130.829 139.969 129.631 138.748 128.156 138.748C126.681 138.748 125.483 139.967 125.483 141.468C125.483 142.97 126.681 144.189 128.156 144.189Z'
        fill='#FFBB53'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M118.903 137.986C107.237 148.405 89.6614 155.052 69.9929 155.052C50.3244 155.052 32.749 148.405 21.0827 137.986C13.5623 130.328 22.46 118.703 31.9774 124.409C45.8887 132.754 79.4143 152.991 118.905 137.986H118.903Z'
        fill='#595959'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.5045 13.1317C42.2667 13.1317 43.669 11.6703 43.669 9.83358C43.669 7.9969 42.2667 6.56641 40.5045 6.56641C38.7423 6.56641 37.373 8.0278 37.373 9.83358C37.373 11.6394 38.7754 13.1317 40.5045 13.1317Z'
        fill='#625FDB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M135.589 57.7748C137.653 57.7748 139.367 56.0223 139.367 53.8145C139.367 51.6066 137.653 49.8965 135.589 49.8965C133.525 49.8965 131.812 51.649 131.812 53.8145C131.812 55.9799 133.525 57.7748 135.589 57.7748Z'
        fill='#E5E5EA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.41232 60.3998C10.4764 60.3998 12.1899 58.6145 12.1899 56.4606C12.1899 54.3067 10.4764 52.5215 8.41232 52.5215C6.34824 52.5215 4.63477 54.3067 4.63477 56.4606C4.63477 58.6145 6.34824 60.3998 8.41232 60.3998Z'
        fill='#3A3A3A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M92.1474 9.19137C94.5769 9.19137 96.5545 7.13177 96.5545 4.59569C96.5545 2.05961 94.5798 0 92.1474 0C89.715 0 87.7402 2.05961 87.7402 4.59569C87.7402 7.13177 89.715 9.19137 92.1474 9.19137Z'
        fill='#FFBB53'
      />
      <path
        d='M32.1168 107.235C38.6662 115.463 39.4875 125.705 39.4875 125.705C39.4875 125.705 30.2693 122.147 23.72 113.919C17.1706 105.691 15.7702 95.91 15.7702 95.91C15.7702 95.91 25.5674 99.0074 32.1168 107.235Z'
        fill='#8578C8'
      />
      <path
        d='M36.5249 103.1C40.1051 112.987 37.6139 122.956 37.6139 122.956C37.6139 122.956 30.0139 116.641 26.4337 106.753C22.8535 96.8654 24.6488 87.1487 24.6488 87.1487C24.6488 87.1487 32.9447 93.2116 36.5249 103.1Z'
        fill='#A092EC'
      />
      <path
        d='M132.675 98.1697C128.627 113.059 117.223 122.922 117.223 122.922C117.223 122.922 113.431 108.928 117.479 94.0385C121.527 79.1487 131.883 69.0013 131.883 69.0013C131.883 69.0013 136.723 83.2799 132.675 98.1697Z'
        fill='#A092EC'
      />
      <rect
        x='35.8711'
        y='26.7246'
        width='82.6254'
        height='105.085'
        rx='10'
        fill='#D9D9D9'
        stroke='#606060'
        strokeWidth='6'
      />
      <ellipse cx='78.5038' cy='76.9567' rx='25.1014' ry='24.7711' fill='#A092EC' />
      <line
        x1='67.6152'
        y1='110.635'
        x2='88.0744'
        y2='110.635'
        stroke='#606060'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='67.6152'
        y1='117.24'
        x2='88.0744'
        y2='117.24'
        stroke='#606060'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <rect x='61.3301' y='22.459' width='34.3493' height='12.5507' rx='3' fill='#5F5F5F' />
      <g clipPath='url(#clip0_8951_94490)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M86.6201 71.3591C86.6201 70.6257 87.2146 70.0312 87.9479 70.0312H89.2757C91.0365 70.0312 92.7252 70.7307 93.9702 71.9758C95.2153 73.2208 95.9147 74.9095 95.9147 76.6703C95.9147 78.431 95.2153 80.1197 93.9702 81.3648C92.7252 82.6098 91.0365 83.3093 89.2757 83.3093H87.9479C87.2146 83.3093 86.6201 82.7148 86.6201 81.9815C86.6201 81.2482 87.2146 80.6537 87.9479 80.6537H89.2757C90.3322 80.6537 91.3454 80.234 92.0924 79.487C92.8395 78.7399 93.2591 77.7267 93.2591 76.6703C93.2591 75.6138 92.8395 74.6006 92.0924 73.8536C91.3454 73.1065 90.3322 72.6869 89.2757 72.6869H87.9479C87.2146 72.6869 86.6201 72.0924 86.6201 71.3591Z'
          fill='#161616'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M65.376 71.3591C65.376 70.6257 65.9705 70.0312 66.7038 70.0312H87.9486C88.682 70.0312 89.2764 70.6257 89.2764 71.3591V83.3093C89.2764 85.0701 88.577 86.7587 87.3319 88.0038C86.0869 89.2488 84.3982 89.9483 82.6374 89.9483H72.015C70.2542 89.9483 68.5656 89.2488 67.3205 88.0038C66.0754 86.7587 65.376 85.0701 65.376 83.3093V71.3591ZM68.0316 72.6869V83.3093C68.0316 84.3658 68.4513 85.3789 69.1983 86.126C69.9453 86.873 70.9585 87.2927 72.015 87.2927H82.6374C83.6939 87.2927 84.7071 86.873 85.4541 86.126C86.2012 85.3789 86.6208 84.3657 86.6208 83.3093V72.6869H68.0316Z'
          fill='#161616'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M72.0143 60.7363C72.7477 60.7363 73.3421 61.3308 73.3421 62.0641V66.0475C73.3421 66.7809 72.7477 67.3753 72.0143 67.3753C71.281 67.3753 70.6865 66.7809 70.6865 66.0475V62.0641C70.6865 61.3308 71.281 60.7363 72.0143 60.7363Z'
          fill='#161616'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M77.3259 60.7363C78.0592 60.7363 78.6537 61.3308 78.6537 62.0641V66.0475C78.6537 66.7809 78.0592 67.3753 77.3259 67.3753C76.5925 67.3753 75.998 66.7809 75.998 66.0475V62.0641C75.998 61.3308 76.5925 60.7363 77.3259 60.7363Z'
          fill='#161616'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M82.6374 60.7363C83.3707 60.7363 83.9652 61.3308 83.9652 62.0641V66.0475C83.9652 66.7809 83.3707 67.3753 82.6374 67.3753C81.904 67.3753 81.3096 66.7809 81.3096 66.0475V62.0641C81.3096 61.3308 81.904 60.7363 82.6374 60.7363Z'
          fill='#161616'
        />
      </g>
      <defs>
        <clipPath id='clip0_8951_94490'>
          <rect
            width='31.8673'
            height='31.8673'
            fill='white'
            transform='translate(64.0479 60.7363)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PausedGoalsGraphic;
